import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { LoadingSpinner } from "@thrivetribe/mvf.ui.molecules.loading-spinner";
import {
  OnboardingPage,
  OnboardingPageBody,
  OnboardingPageContent,
  OnboardingPageCopy,
  OnboardingPageFooter,
} from "@thrivetribe/mvf.ui.organisms.onboarding-page";
import { useUser } from "components/user/UserContext";
import { Gtag } from "configs/ReactGa";
import { signupNavLink } from "Onboarding/utils";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { useGetUserQuery, useUpdateUserMutation } from "redux/userApiSlice";
import { ReactComponent as Club } from "../../assets/img/club.svg";
import { ReactComponent as Gym } from "../../assets/img/gym.svg";
import { ReactComponent as Receipe } from "../../assets/img/receipe.svg";
import { ReactComponent as Weight } from "../../assets/img/weight.svg";
import { ImagesUrl } from "configs/EnvironmentConfig";
import "./PortalComplete.scss";

const PortalComplete = () => {
  let navigate = useNavigate();
  let user = useUser();
  let { data: userObj, isLoading } = useGetUserQuery(user?.userId);
  let [updateProfile] = useUpdateUserMutation({
    fixedCacheKey: user?.userId,
  });

  const updateProfileData = async (userStatus: string) => {
    if (userObj) {
      const updatedProfile = { ...userObj, userStatus };
      await updateProfile(updatedProfile)
        .unwrap()
        .then(() => {
          user.isValid = true;
          Gtag("event", "end_account_setup", {
            user_id: user.userId,
            event_category: "account setup",
          });
          navigate("/");
        });
    }
  };

  const handleSubmit = async () => {
    await updateProfileData("valid").then(() => {
      return <></>;
    });
  };

  const handleBack = () => {
    if (userObj?.healthConditionDetails?.medication) {
      navigate("/portal-setup/specify-medication");
    } else {
      navigate("/portal-setup/any-medication");
    }
  };

  if (isLoading) {
    return <LoadingSpinner fullscreen={true} />;
  }

  return (
    <div className="portal-complete">
      <Helmet>
        <title>Set up - Complete</title>
      </Helmet>
      <OnboardingPage
        user={user.displayName}
        links={signupNavLink}
        image={`${ImagesUrl}/group.webp`}
        title={"Set up"}
        onBackClick={() => navigate(-1)}
      >
        <OnboardingPageContent hasStickyFooter>
          <OnboardingPageBody>
            <OnboardingPageCopy>
              <h1>That's it, good to go!</h1>
              <p>You've scored full access to The Dugout. Time to start exploring...</p>
              <p>
                <b>What will you check out first?</b>
              </p>
            </OnboardingPageCopy>
            <div className="portal-complete__checklist">
              <Receipe />
              <p>Try easy, healthy recipes to keep you going before and after training</p>
            </div>
            <div className="portal-complete__checklist">
              <Gym />
              <p>Access our awesome online gym, MAN v FAT Gym</p>
            </div>
            <div className="portal-complete__checklist">
              <Weight />
              <p>
                Read articles, tips and tricks to help you lose weight and become a pro on diet, exercise and loads more
              </p>
            </div>
            <div className="portal-complete__checklist">
              <Club />
              <p>All your club details, the latest results and fixtures</p>
            </div>
          </OnboardingPageBody>
          <OnboardingPageFooter>
            <Button onClick={handleSubmit} variant="primary" color="primary">
              Head over to The Dugout
              <ButtonArrow />
            </Button>
          </OnboardingPageFooter>
        </OnboardingPageContent>
      </OnboardingPage>
    </div>
  );
};

export default PortalComplete;
